import { setErrorDialog, serverUrl, getheader, getMethodByCallBack, cacheTypes, postMethodByDispatcher, postMethodByCallBack } from "../../../store/api/CommonFunctions";
export function getComplaintsMainGroupList(onGet) {
    getMethodByCallBack("api/ComplaintsAPI/GetComplaintsMainGroupList", cacheTypes.NoCache, onGet, "GET_COMPLAINT_MAINGROUP");
}
export function getComplaintsSubGroup(mainGroupID, onGet) {
    getMethodByCallBack(`api/ComplaintsAPI/GetComplaintsSubGroup?mainGroupID=${mainGroupID}`, cacheTypes.NoCache, onGet, "getComplaintsSubGroup");
}
export function getComplaintsTargetList(onGet) {
    getMethodByCallBack("api/ComplaintsAPI/GetComplaintsTargetList", cacheTypes.NoCache, onGet, "GetComplaintsTargetList");
}
export function addEditComplaint(data, onSuccess) {
    return dispatch => {
        fetch(serverUrl + "api/ComplaintsAPI/AddEditComplaint", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    setErrorDialog(dispatch, res.Message, "ثبت شکایت");
                    res = null;
                }
                else {
                    setErrorDialog(dispatch, "ثبت با موفقیت انجام شد. شماره پیگیری: " + res.TrackingNumber, "ثبت شکایت");
                    if (onSuccess) {
                        onSuccess(res.ID);
                    }
                }
            })
    }
}
export function getComplaintList(serial) {
    return dispatch => {
        dispatch({
            type: "GET_COMPLAINT_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/ComplaintsAPI/GetCustomerComplaintList?productSerial=" + serial, {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message) {
                    res = null;
                }
                return dispatch({
                    type: "GET_COMPLAINT_LIST",
                    data: res
                });
            })
    }
}
export function getComplaintStatusList(onGet) {
    getMethodByCallBack("api/ComplaintsAPI/GetComplaintsStatusList", cacheTypes.NoCache, onGet, "GetComplaintsStatusList");
}
export function getComplaintBaseInfoes(onGet) {
    getMethodByCallBack(`api/ComplaintsAPI/GetComplaintBaseInfoes`, cacheTypes.NoCache, onGet, "GetComplaintBaseInfoes");
}
export function closeComplaint(closeDesc, id, satisfaction, onClose) {
    postMethodByCallBack(`api/ComplaintsAPI/CloseComplaint?id=${id}&satisfaction=${satisfaction}`, closeDesc,onClose, "CloseComplaint");

}
export function addEditComplaintMainGroup(data, onAddEdit) {
    postMethodByCallBack("api/ComplaintsAPI/AddEditComplaintMainGroup", data, onAddEdit, "AddEditComplaintMainGroup");
}
export function deleteComplaintsMainGroup(id, onDelete) {
    getMethodByCallBack(`api/ComplaintsAPI/DeleteComplaintsMainGroup?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteComplaintsMainGroup");
}
export function addEditComplaintsSubGroup(data, onAddEdit) {
    postMethodByCallBack("api/ComplaintsAPI/AddEditComplaintsSubGroup", data, onAddEdit, "AddEditComplaintsSubGroup");
}
export function deleteComplaintsSubGroup(id, onDelete) {
    getMethodByCallBack(`api/ComplaintsAPI/DeleteComplaintsSubGroup?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteComplaintsSubGroup");
}
export function addEditComplaintsTarget(data, onAddEdit) {
    postMethodByCallBack(`api/ComplaintsAPI/AddEditComplaintsTarget?`, data, onAddEdit, "AddEditComplaintsTarget");
}
export function deleteComplaintsTarget(id, onDelete) {
    getMethodByCallBack(`api/ComplaintsAPI/DeleteComplaintsTarget?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteComplaintsTarget");
}
export function addEditComplaintsStatus(data, onAddEdit) {
    postMethodByCallBack("api/ComplaintsAPI/AddEditComplaintsStatus", data, onAddEdit, "AddEditComplaintsStatus");
}
export function deleteComplaintsStatus(id, onDelete) {
    getMethodByCallBack(`api/ComplaintsAPI/DeleteComplaintsStatus?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteComplaintsStatus");
}
export function getComplaintsTypeList(onGet) {
    getMethodByCallBack(`api/ComplaintsAPI/GetComplaintsTypeList`, cacheTypes.NoCache, onGet, "GetComplaintsTypeList");
}
export function addEditComplaintsType(data, onAddEdit) {
    postMethodByCallBack("api/ComplaintsAPI/AddEditComplaintsType", data, onAddEdit, "AddEditComplaintsType");
}
export function deleteComplaintsType(id, onDelete) {
    getMethodByCallBack(`api/ComplaintsAPI/DeleteComplaintsType?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteComplaintsType");
}
export function addEditComplaintsSource(data, onAddEdit) {
    postMethodByCallBack(`api/ComplaintsAPI/AddEditComplaintsSource`, data, onAddEdit, "AddEditComplaintsSource");
}
export function deleteComplaintsSource(id, onDelete) {
    getMethodByCallBack(`api/ComplaintsAPI/DeleteComplaintsSource?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteComplaintsSource");
}
export function searchComplaints(data, onSearch) {
    return dispatch => {
        dispatch({
            type: "COMPLAINT_FILTERS",
            data: data
        });
        dispatch(postMethodByDispatcher("api/ComplaintsAPI/SearchComplaints", data, "SEARCH_COMPLAINTS","جستجوی شکایت", onSearch));
    }
}
export function deleteComplaint(id, onDelete)
{
    getMethodByCallBack(`api/ComplaintsAPI/DeleteComplaint?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteComplaint");
}
export function getComplaint(id, onGet)
{
    getMethodByCallBack(`api/ComplaintsAPI/GetComplaint?id=${id}`, cacheTypes.NoCache, onGet, "GetComplaint");
}
export function getWaitingSMSOrWebRequests(data)
{
    return dispatch=>{
        dispatch({
            type:"W_SMS_WEB_REQ_FILTERS",
            data:data
        })
        dispatch(postMethodByDispatcher("api/Complaints_RequestBySMSOrWebAPI/GetWaitingSMSOrWebRequests",data,"W_SMS_WEB_REQ", "صدای مشتری"));
    }
}
export function deleteSMSOrWebRequest(id, onDelete)
{
    getMethodByCallBack(`api/Complaints_RequestBySMSOrWebAPI/DeleteRequest?id=${id}`, cacheTypes.NoCache, onDelete,"DeleteRequest");;
}
